export const salesRoles = [
  "Account executive",
  "Account manager",
  "Appointment setter",
  "Business development manager",
  "Business manager",
  "Customer success",
  "Fundraiser",
  "High-Ticket Closer",
  "Recruitment consultant",
  "Sales executive",
  "Sales manager",
  "SDR or BDR",
] as const;

export const salespersonCountries = [
  "Australia",
  "Ireland",
  "United Kingdom",
  "United States",
  "Other",
] as const;

export const salesSectors = [
  "Recruitment",
  "Charity and fundraising",
  "SaaS and technology",
  "Financial services",
  "Telecoms and energy",
  "Education and training",
  "Property and construction",
  "Health and care",
  "Media and advertising",
  "Marketing and agencies",
  "Coaching and consulting",
  "Retail and ecommerce",
] as const;
